export type ItemTypes3 = {
  type_id: string;
  type_category: string;
  type_subcategory: string;
  type_specs: string;
  type_label_long?: string;
  type_label_display: string;
  fr_gender?: "m" | "f";
  fr_vowel_sound?: boolean;
};

export const ITEM_TYPES: ItemTypes3[] = [
  /*{
    type_category: "Accessories",
    type_subcategory: "Hats & Caps",
    type_specs: "Berets",
    type_label_long: "Berets",
    type_label_display: "Hat",
    type_id: "82650378",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Hats & Caps",
    type_specs: "Caps",
    type_label_long: "Caps",
    type_label_display: "Hat",
    type_id: "36926565",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Hats & Caps",
    type_specs: "Hats",
    type_label_long: "Hats",
    type_label_display: "Hat",
    type_id: "31394505",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Hats & Caps",
    type_specs: "Headbands",
    type_label_long: "Headbands",
    type_label_display: "Hat",
    type_id: "10292224",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Hats & Caps",
    type_specs: "Helmet",
    type_label_long: "Helmet",
    type_label_display: "Helmet",
    type_id: "57801717",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Hats & Caps",
    type_specs: "Other",
    type_label_long: "Hats & Caps - Other",
    type_label_display: "Hat",
    type_id: "49105467",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Hats & Caps",
    type_specs: "Winter hats",
    type_label_long: "Winter hats",
    type_label_display: "Hat",
    type_id: "20649521",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Jewellery",
    type_specs: "Anklets",
    type_label_long: "Anklets",
    type_label_display: "Accessory",
    type_id: "83894456",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Jewellery",
    type_specs: "Bracelets",
    type_label_long: "Bracelets",
    type_label_display: "Accessory",
    type_id: "70109535",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Jewellery",
    type_specs: "Brooches",
    type_label_long: "Brooches",
    type_label_display: "Accessory",
    type_id: "20412040",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Jewellery",
    type_specs: "Cufflinks",
    type_label_long: "Cufflinks",
    type_label_display: "Accessory",
    type_id: "63268153",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Jewellery",
    type_specs: "Earrings",
    type_label_long: "Earrings",
    type_label_display: "Accessory",
    type_id: "68810076",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Jewellery",
    type_specs: "Necklace",
    type_label_long: "Necklace",
    type_label_display: "Accessories",
    type_id: "02894625",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Jewellery",
    type_specs: "Pendant",
    type_label_long: "Pendant",
    type_label_display: "Accessory",
    type_id: "53797200",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Jewellery",
    type_specs: "Rings",
    type_label_long: "Rings",
    type_label_display: "Accessory",
    type_id: "69565003",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Other",
    type_specs: "Belts",
    type_label_long: "Belts",
    type_label_display: "Belt",
    type_id: "42289350",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Other",
    type_specs: "Gloves",
    type_label_long: "Gloves",
    type_label_display: "Gloves",
    type_id: "12755222",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Other",
    type_specs: "Other",
    type_label_long: "Accessories - Other",
    type_label_display: "Accessory",
    type_id: "30320078",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Protections",
    type_specs: "Arm bandages",
    type_label_long: "Bandages - Arm",
    type_label_display: "Bandages for the arm",
    type_id: "02975628",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Protections",
    type_specs: "Back protection",
    type_label_long: "Accessories - Back protection",
    type_label_display: "Back protection",
    type_id: "24310882",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Protections",
    type_specs: "Knee bandages",
    type_label_long: "Bandages - Knee",
    type_label_display: "Bandages for the knee",
    type_id: "12105017",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Protections",
    type_specs: "Leg bandages",
    type_label_long: "Bandages - Leg",
    type_label_display: "Bandages for the leg",
    type_id: "76158366",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Protections",
    type_specs: "Shoulder bandages",
    type_label_long: "Bandages - Shoulder",
    type_label_display: "Bandages for the shoulder",
    type_id: "87235977",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Scarves & Shawls",
    type_specs: "Head scarves",
    type_label_long: "Head scarves",
    type_label_display: "Scarf",
    type_id: "43711372",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Scarves & Shawls",
    type_specs: "Knit scarves",
    type_label_long: "Knit scarves",
    type_label_display: "Scarf",
    type_id: "65043423",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Accessories",
    type_subcategory: "Scarves & Shawls",
    type_specs: "Shawls",
    type_label_long: "Shawls",
    type_label_display: "Scarf",
    type_id: "14413174",
    fr_gender: "m",
    fr_vowel_sound: false,
  },*/
  {
    type_category: "Bottom",
    type_subcategory: "Activewear",
    type_specs: "Joggers",
    type_label_long: "Joggers",
    type_label_display: "Joggers",
    type_id: "21505194",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Activewear",
    type_specs: "Leggings",
    type_label_long: "Leggings",
    type_label_display: "Leggings",
    type_id: "74296886",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Activewear",
    type_specs: "Shorts",
    type_label_long: "Activewear shorts",
    type_label_display: "Shorts",
    type_id: "47810453",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Jeans & Pants",
    type_specs: "Chinos",
    type_label_long: "Chinos",
    type_label_display: "Pants",
    type_id: "16750538",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Jeans & Pants",
    type_specs: "Cropped pants",
    type_label_long: "Cropped pants",
    type_label_display: "Pants",
    type_id: "08305908",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Jeans & Pants",
    type_specs: "Jeans",
    type_label_long: "Jeans",
    type_label_display: "Jeans",
    type_id: "34174858",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Jeans & Pants",
    type_specs: "Other",
    type_label_long: "Jeans & Pants - Other",
    type_label_display: "Pants",
    type_id: "44002988",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Jeans & Pants",
    type_specs: "Tailored pants",
    type_label_long: "Tailored pants",
    type_label_display: "Pants",
    type_id: "54576579",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Pyjama",
    type_specs: "Lace shorts",
    type_label_long: "Pyjama - Lace shorts",
    type_label_display: "Pyjama",
    type_id: "43595438",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Pyjama",
    type_specs: "Nightwear",
    type_label_long: "Pyjama - Nightwear",
    type_label_display: "Nightgown",
    type_id: "88008157",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Pyjama",
    type_specs: "Pants",
    type_label_long: "Pyjama - Pants",
    type_label_display: "Pyjama",
    type_id: "48873705",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Pyjama",
    type_specs: "Shorts",
    type_label_long: "Pyjama - Shorts",
    type_label_display: "Pyjama",
    type_id: "88142132",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Shorts",
    type_specs: "High-waisted shorts",
    type_label_long: "High-waisted shorts",
    type_label_display: "Shorts",
    type_id: "94011659",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Shorts",
    type_specs: "Low-waisted shorts",
    type_label_long: "Low-waisted shorts",
    type_label_display: "Shorts",
    type_id: "76363809",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Shorts",
    type_specs: "Mini shorts",
    type_label_long: "Mini shorts",
    type_label_display: "Shorts",
    type_id: "90406840",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Shorts",
    type_specs: "Regular shorts",
    type_label_long: "Regular shorts",
    type_label_display: "Shorts",
    type_id: "86315535",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Skirt",
    type_specs: "A-line skirt",
    type_label_long: "A-line skirt",
    type_label_display: "Skirt",
    type_id: "83910803",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Skirt",
    type_specs: "High-waisted skirt",
    type_label_long: "High-waisted skirt",
    type_label_display: "Skirt",
    type_id: "79148510",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Skirt",
    type_specs: "Maxi skirt",
    type_label_long: "Maxi skirt",
    type_label_display: "Skirt",
    type_id: "99394154",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Skirt",
    type_specs: "Midi skirt",
    type_label_long: "Midi skirt",
    type_label_display: "Skirt",
    type_id: "96188183",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Skirt",
    type_specs: "Mini skirt",
    type_label_long: "Mini skirt",
    type_label_display: "Skirt",
    type_id: "32857063",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Skirt",
    type_specs: "Other skirt",
    type_label_long: "Skirt - Other",
    type_label_display: "Skirt",
    type_id: "17783458",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Bottom",
    type_subcategory: "Skirt",
    type_specs: "Skater skirt",
    type_label_long: "Skater skirt",
    type_label_display: "Skirt",
    type_id: "19283629",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Full Body",
    type_subcategory: "Dress",
    type_specs: "Formal dress",
    type_label_long: "Formal dress",
    type_label_display: "Dress",
    type_id: "55958662",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Full Body",
    type_subcategory: "Dress",
    type_specs: "Long dress",
    type_label_long: "Long dress",
    type_label_display: "Dress",
    type_id: "83483988",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Full Body",
    type_subcategory: "Dress",
    type_specs: "Midi-dress",
    type_label_long: "Midi-dress",
    type_label_display: "Dress",
    type_id: "97589317",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Full Body",
    type_subcategory: "Dress",
    type_specs: "Mini-dress",
    type_label_long: "Mini-dress",
    type_label_display: "Dress",
    type_id: "69140261",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Full Body",
    type_subcategory: "Dress",
    type_specs: "Other dress",
    type_label_long: "Dress - Other",
    type_label_display: "Dress",
    type_id: "19315767",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Full Body",
    type_subcategory: "Dress",
    type_specs: "Tunic",
    type_label_long: "Tunic",
    type_label_display: "Tunic",
    type_id: "69992661",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Full Body",
    type_subcategory: "Home & Pyjama",
    type_specs: "Bathrobes",
    type_label_long: "Full Body - Bathrobes",
    type_label_display: "Bathrobe",
    type_id: "72221337",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Full Body",
    type_subcategory: "Home & Pyjama",
    type_specs: "Pyjama",
    type_label_long: "Full Body - Pyjama",
    type_label_display: "Pyjama",
    type_id: "94615745",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Full Body",
    type_subcategory: "Other",
    type_specs: "Jumpsuit",
    type_label_long: "Jumpsuit",
    type_label_display: "Overall",
    type_id: "64766852",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Full Body",
    type_subcategory: "Other",
    type_specs: "Playsuit",
    type_label_long: "Playsuits",
    type_label_display: "Overall",
    type_id: "12154776",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Full Body",
    type_subcategory: "Other",
    type_specs: "Suit",
    type_label_long: "Suit",
    type_label_display: "Suit",
    type_id: "38640279",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Full Body",
    type_subcategory: "Other",
    type_specs: "Tuxedo",
    type_label_long: "Tuxedo",
    type_label_display: "Suit",
    type_id: "45755619",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Coat",
    type_specs: "Duffle coat",
    type_label_long: "Dufflecoat",
    type_label_display: "Coat",
    type_id: "23910726",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Coat",
    type_specs: "Long coat",
    type_label_long: "Long coat",
    type_label_display: "Coat",
    type_id: "03566276",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Coat",
    type_specs: "Other",
    type_label_long: "Coats - Other",
    type_label_display: "Coat",
    type_id: "13284782",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Coat",
    type_specs: "Parka",
    type_label_long: "Parka",
    type_label_display: "Coat",
    type_id: "08476828",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Coat",
    type_specs: "Peacoat",
    type_label_long: "Peacoat",
    type_label_display: "Coat",
    type_id: "32386852",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Coat",
    type_specs: "Raincoat",
    type_label_long: "Raincoat",
    type_label_display: "Raincoat",
    type_id: "23116965",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Coat",
    type_specs: "Trench coat",
    type_label_long: "Trenchcoat",
    type_label_display: "Coat",
    type_id: "13091484",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Biker jacket",
    type_label_long: "Biker jacket",
    type_label_display: "Jacket",
    type_id: "90412186",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Blazer",
    type_label_long: "Blazer",
    type_label_display: "Blazer",
    type_id: "87128109",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Bomber jacket",
    type_label_long: "Bomber jacket",
    type_label_display: "Jacket",
    type_id: "09060312",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Denim jacket",
    type_label_long: "Denim jacket",
    type_label_display: "Jacket",
    type_id: "16077218",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Field jacket",
    type_label_long: "Field jacket",
    type_label_display: "Jacket",
    type_id: "20011656",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Fleece jacket",
    type_label_long: "Fleece jacket",
    type_label_display: "Jacket",
    type_id: "81937374",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Harrington jacket",
    type_label_long: "Harrington jacket",
    type_label_display: "Jacket",
    type_id: "70478628",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Other",
    type_label_long: "Jackets - Other",
    type_label_display: "Outerwear",
    type_id: "05389207",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Puffer jacket",
    type_label_long: "Puffer jacket",
    type_label_display: "Down jacket",
    type_id: "41563984",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Quilted jacket",
    type_label_long: "Quilted jacket",
    type_label_display: "Jacket",
    type_id: "83293623",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Shacket",
    type_label_long: "Shacket",
    type_label_display: "Jacket",
    type_id: "57623985",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Ski & Snowboard jacket",
    type_label_long: "Ski & Snowboard jacket",
    type_label_display: "Outerwear",
    type_id: "06928788",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Trekking vest",
    type_label_long: "Trekking vest",
    type_label_display: "Outerwear",
    type_id: "00009512",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Varsity jacket",
    type_label_long: "Varsity jacket",
    type_label_display: "Jacket",
    type_id: "41854556",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Outerwear",
    type_subcategory: "Jacket",
    type_specs: "Windbreakers",
    type_label_long: "Windbreaker",
    type_label_display: "Jacket",
    type_id: "49094426",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Boots",
    type_specs: "Ankle boots",
    type_label_long: "Ankle boots",
    type_label_display: "Shoes",
    type_id: "44703235",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Boots",
    type_specs: "Chelsea & slip-on boots",
    type_label_long: "Chelsea & slip-on boots",
    type_label_display: "Shoes",
    type_id: "41586708",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Boots",
    type_specs: "Desert & lace-up boots",
    type_label_long: "Desert & lace-up boots",
    type_label_display: "Shoes",
    type_id: "01704642",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Boots",
    type_specs: "Knee-high boots",
    type_label_long: "Knee-high boots",
    type_label_display: "Knee-highs",
    type_id: "04937646",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Boots",
    type_specs: "Mid-calf boots",
    type_label_long: "Mid-calf boots",
    type_label_display: "Shoes",
    type_id: "60417578",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Boots",
    type_specs: "Over-the-knee boots",
    type_label_long: "Over-the-knee boots",
    type_label_display: "Shoes",
    type_id: "11657985",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Boots",
    type_specs: "Snow boots",
    type_label_long: "Snow boots",
    type_label_display: "Shoes",
    type_id: "99368628",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Boots",
    type_specs: "Wellington boots",
    type_label_long: "Wellington boots",
    type_label_display: "Shoes",
    type_id: "79375055",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Boots",
    type_specs: "Work boots",
    type_label_long: "Work boots",
    type_label_display: "Shoes",
    type_id: "56887816",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Flat shoes",
    type_specs: "Ballerinas",
    type_label_long: "Ballerinas",
    type_label_display: "Shoes",
    type_id: "18063848",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Flat shoes",
    type_specs: "Boat shoes",
    type_label_long: "Boat shoes",
    type_label_display: "Shoes",
    type_id: "87802997",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Flat shoes",
    type_specs: "Espadrilles",
    type_label_long: "Espadrilles",
    type_label_display: "Shoes",
    type_id: "57995316",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Flat shoes",
    type_specs: "Lace-up shoes",
    type_label_long: "Lace-up shoes",
    type_label_display: "Shoes",
    type_id: "20249542",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Flat shoes",
    type_specs: "Mary Janes",
    type_label_long: "Mary Janes",
    type_label_display: "Shoes",
    type_id: "82585941",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Formal shoes",
    type_specs: "Derby shoes",
    type_label_long: "Derby shoes",
    type_label_display: "Shoes",
    type_id: "66655378",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Formal shoes",
    type_specs: "Monk strap shoes",
    type_label_long: "Monk strap shoes",
    type_label_display: "Shoes",
    type_id: "48430940",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Formal shoes",
    type_specs: "Oxford shoes",
    type_label_long: "Oxford shoes",
    type_label_display: "Shoes",
    type_id: "92778690",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Formal shoes",
    type_specs: "Slip-on shoes",
    type_label_long: "Slip-on shoes",
    type_label_display: "Shoes",
    type_id: "54094579",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Heels",
    type_specs: "Court shoes",
    type_label_long: "Court shoes",
    type_label_display: "Shoes",
    type_id: "25526881",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Heels",
    type_specs: "High-heeled sandals",
    type_label_long: "High-heeled sandals",
    type_label_display: "Shoes",
    type_id: "58012479",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Lifestyle",
    type_specs: "Sneakers",
    type_label_long: "Sneakers",
    type_label_display: "Shoes",
    type_id: "79998086",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Lifestyle",
    type_specs: "Trainers",
    type_label_long: "Trainers",
    type_label_display: "Shoes",
    type_id: "93791354",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Other",
    type_specs: "Clogs & mules",
    type_label_long: "Clogs & mules",
    type_label_display: "Shoes",
    type_id: "43418236",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Other",
    type_specs: "Flip-flops",
    type_label_long: "Flip-flops",
    type_label_display: "Shoes",
    type_id: "11809950",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Other",
    type_specs: "Other",
    type_label_long: "Shoes - Other",
    type_label_display: "Shoes",
    type_id: "74675693",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Other",
    type_specs: "Sandals",
    type_label_long: "Sandals",
    type_label_display: "Shoes",
    type_id: "60211140",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Other",
    type_specs: "Slides",
    type_label_long: "Slides",
    type_label_display: "Shoes",
    type_id: "61013330",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Other",
    type_specs: "Slippers",
    type_label_long: "Slippers",
    type_label_display: "Shoes",
    type_id: "77865173",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Basketball",
    type_label_long: "Basketball shoes",
    type_label_display: "Shoes",
    type_id: "53332908",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Climbing",
    type_label_long: "Climbing & bouldering shoes",
    type_label_display: "Shoes",
    type_id: "81957645",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Cycling",
    type_label_long: "Cycling shoes",
    type_label_display: "Shoes",
    type_id: "78715454",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Dance",
    type_label_long: "Dance shoes",
    type_label_display: "Shoes",
    type_id: "25825496",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Football",
    type_label_long: "Football boots",
    type_label_display: "Shoes",
    type_id: "40761380",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Golf",
    type_label_long: "Golf shoes",
    type_label_display: "Shoes",
    type_id: "60061505",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Handball",
    type_label_long: "Handball shoes",
    type_label_display: "Shoes",
    type_id: "35536598",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Hiking",
    type_label_long: "Hiking boots & shoes",
    type_label_display: "Shoes",
    type_id: "05299463",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Ice skating",
    type_label_long: "Ice skates",
    type_label_display: "Shoes",
    type_id: "22603980",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Indoor football",
    type_label_long: "Indoor football shoes",
    type_label_display: "Shoes",
    type_id: "46073277",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Indoor training",
    type_label_long: "Indoor training shoes",
    type_label_display: "Shoes",
    type_id: "13969982",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Motorcycle",
    type_label_long: "Motorcycle boots",
    type_label_display: "Shoes",
    type_id: "73999093",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Other",
    type_label_long: "Sports shoes - Other",
    type_label_display: "Shoes",
    type_id: "79102260",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Roller & inline skating",
    type_label_long: "Roller skates & inline skates",
    type_label_display: "Shoes",
    type_id: "69099054",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Running",
    type_label_long: "Running shoes",
    type_label_display: "Shoes",
    type_id: "46145778",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Ski",
    type_label_long: "Ski boots",
    type_label_display: "Shoes",
    type_id: "31536197",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Snowboard",
    type_label_long: "Snowboard boots",
    type_label_display: "Shoes",
    type_id: "46265715",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Swimming & water",
    type_label_long: "Swimming & water shoes",
    type_label_display: "Shoes",
    type_id: "49055537",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Shoes",
    type_subcategory: "Sports shoes",
    type_specs: "Tennis",
    type_label_long: "Tennis shoes",
    type_label_display: "Shoes",
    type_id: "28207149",
    fr_gender: "f",
    fr_vowel_sound: false,
  },
  {
    type_category: "Swimwear",
    type_subcategory: "Bikini (set)",
    type_specs: "",
    type_label_long: "Bikini",
    type_label_display: "Swimwear",
    type_id: "75663305",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Swimwear",
    type_subcategory: "Cover-ups & Sarongs",
    type_specs: "",
    type_label_long: "Cover-ups & Sarongs",
    type_label_display: "Swimwear",
    type_id: "80015088",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Swimwear",
    type_subcategory: "One-piece",
    type_specs: "",
    type_label_long: "Swimwear - One-piece",
    type_label_display: "Swimwear",
    type_id: "83693712",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Swimwear",
    type_subcategory: "Other",
    type_specs: "Swimwear (bottom)",
    type_label_long: "Swimwear - Bottom",
    type_label_display: "Swimwear",
    type_id: "99895008",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Swimwear",
    type_subcategory: "Other",
    type_specs: "Swimwear (top)",
    type_label_long: "Swimwear -Top",
    type_label_display: "Swimwear",
    type_id: "90962158",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Cardigans & Vests",
    type_specs: "Cardigan",
    type_label_long: "Cardigan",
    type_label_display: "Vest",
    type_id: "20124568",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Cardigans & Vests",
    type_specs: "Vest",
    type_label_long: "Vest",
    type_label_display: "Vest",
    type_id: "68425186",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Crop-top",
    type_specs: "Long-sleeve",
    type_label_long: "Long-sleeve Crop-top",
    type_label_display: "T-shirt",
    type_id: "45056843",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Crop-top",
    type_specs: "Short-sleeve",
    type_label_long: "Short-sleeve Crop-top",
    type_label_display: "T-shirt",
    type_id: "26780350",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Hoodie",
    type_specs: "No zip",
    type_label_long: "Hoodie - No zip",
    type_label_display: "Hoodie",
    type_id: "17955901",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Hoodie",
    type_specs: "Zipped",
    type_label_long: "Hoodie - Zipped",
    type_label_display: "Hoodie",
    type_id: "45882586",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Polo",
    type_specs: "Long-sleeve",
    type_label_long: "Long-sleeve Polo",
    type_label_display: "Polo",
    type_id: "58764447",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Polo",
    type_specs: "Short-sleeve",
    type_label_long: "Short-sleeve Polo",
    type_label_display: "Polo",
    type_id: "56254318",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Pyjama",
    type_specs: "",
    type_label_long: "Top - Pyjama",
    type_label_display: "Pyjama",
    type_id: "30233750",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Shirt",
    type_specs: "Long-sleeve",
    type_label_long: "Long-sleeve shirt",
    type_label_display: "Shirt",
    type_id: "49736281",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Shirt",
    type_specs: "Short-sleeve",
    type_label_long: "Short-sleeve shirt",
    type_label_display: "Shirt",
    type_id: "42002124",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Sweater",
    type_specs: "Other",
    type_label_long: "Sweater - Other",
    type_label_display: "Sweater",
    type_id: "04619641",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Sweater",
    type_specs: "Round neck",
    type_label_long: "Sweater - Round neck",
    type_label_display: "Sweater",
    type_id: "08268165",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Sweater",
    type_specs: "Shawl neck",
    type_label_long: "Sweater - Shawl neck",
    type_label_display: "Sweater",
    type_id: "75115708",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Sweater",
    type_specs: "Sleeveless",
    type_label_long: "Sweater - Sleeveless",
    type_label_display: "Sweater",
    type_id: "37705599",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Sweater",
    type_specs: "Turtle neck",
    type_label_long: "Sweater - Turtle neck",
    type_label_display: "Sweater",
    type_id: "02306779",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "Sweater",
    type_specs: "V-neck",
    type_label_long: "Sweater - V-neck",
    type_label_display: "Sweater",
    type_id: "28005899",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "T-shirt",
    type_specs: "Long-sleeve",
    type_label_long: "Long-sleeve T-shirt",
    type_label_display: "T-shirt",
    type_id: "71957756",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Top",
    type_subcategory: "T-shirt",
    type_specs: "Short-sleeve",
    type_label_long: "Short-sleeve T-shirt",
    type_label_display: "T-shirt",
    type_id: "89348108",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Underwear",
    type_subcategory: "Bras",
    type_specs: "Bralette",
    type_label_long: "Bras - Bralette",
    type_label_display: "Bra",
    type_id: "46560951",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Underwear",
    type_subcategory: "Bras",
    type_specs: "Other",
    type_label_long: "Bras - Other",
    type_label_display: "Bra",
    type_id: "03087343",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Underwear",
    type_subcategory: "Bras",
    type_specs: "Push-ups",
    type_label_long: "Bras - Push-ups",
    type_label_display: "Bra",
    type_id: "59135794",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Underwear",
    type_subcategory: "Bras",
    type_specs: "Underwired",
    type_label_long: "Bras - Underwired",
    type_label_display: "Bra",
    type_id: "00925536",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Underwear",
    type_subcategory: "Panties & Briefs",
    type_specs: "Boxer briefs",
    type_label_long: "Underwear - Boxer briefs",
    type_label_display: "Underwear (bottom)",
    type_id: "19336870",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Underwear",
    type_subcategory: "Panties & Briefs",
    type_specs: "Briefs",
    type_label_long: "Underwear - briefs",
    type_label_display: "Underwear (bottom)",
    type_id: "94666763",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Underwear",
    type_subcategory: "Panties & Briefs",
    type_specs: "Panties",
    type_label_long: "Underwear - Panties",
    type_label_display: "Underwear (bottom)",
    type_id: "39757496",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Underwear",
    type_subcategory: "Panties & Briefs",
    type_specs: "Shapewear",
    type_label_long: "Underwear - Shapewear",
    type_label_display: "Underwear (bottom)",
    type_id: "82443190",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Underwear",
    type_subcategory: "Socks & Stockings",
    type_specs: "Socks",
    type_label_long: "Socks",
    type_label_display: "Socks",
    type_id: "76883507",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Underwear",
    type_subcategory: "Socks & Stockings",
    type_specs: "Stockings",
    type_label_long: "Stockings",
    type_label_display: "Tights & stockings",
    type_id: "73305888",
    fr_gender: "m",
    fr_vowel_sound: false,
  },
  {
    type_category: "Underwear",
    type_subcategory: "Socks & Stockings",
    type_specs: "Tights",
    type_label_long: "Tights",
    type_label_display: "Tights & stockings",
    type_id: "94798128",
    fr_gender: "m",
    fr_vowel_sound: false,
  }
]